Ext.define('PanelSkpPomiaryAnaliza', {
    extend: 'Ext.container.Container',
    alias: "widget.panelskppomiaryanaliza",
    layout: {
        type: "vbox",
        align: "stretch"
    },
    scrollable: true,
    dataForStore: [],
    initComponent: function () {
        this.cid = Ext.id();
        var store = Ext.create('Ext.data.Store', {
            type: 'store',
            model: Ext.define(null, {
                extend: 'Ext.data.Model',
                fields: ["sxcat", "arytm", "sonda", "diff"]
            }),
            proxy: {
                type: 'memory',
                reader: {
                    type: "json"
                }
            }
        });
        var topPanel = {
            xtype: "toolbar",
            docked: 'top',
            layout: "hbox",
            items: [{
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconRefresh",
                padding: 10,
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.onReportReload
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: 'iconPDF',
                padding: 10,
                text: Lang.pdf.capitalise(),
                scope: this,
                handler: this.downloadPDF
            }, '-', {
                id: this.cid + "idzbiornik",
                xtype: 'combobox',
                fieldLabel: Lang.zbiornik,
                valueField: 'id',
                labelWidth: 80,
                displayField: 'nazwa',
                padding: 7,
                queryMode: 'local',
                store: new Ext.data.JsonStore({
                    sorters: [Ext.bind(customLocaleSort, this, ["nazwa"], true)],
                    fields: ['id', 'nazwa'],
                    proxy: {
                        type: 'memory',
                        reader: {
                            type: "json"
                        }
                    }
                }),
                allowBlank: false,
                editable: false
            }]
        };
        var periodSelector = {
            xtype: "container",
            layout: {
                type: 'hbox',
                align: 'center'
            },
            items: [{
                xtype: "panelreportingreporttypeselect",
                id: this.cid + "reporttype",
                flex: 3,
                listeners: {
                    scope: this,
                    selectrow: this.onChangeReportType
                }
            }, {
                xtype: "panelreportingczasselect",
                id: this.cid + "datemanipulationt",
                height: 44,
                flex: 1,
                stateValue: "day",
                hideNowTypeSelect: true,
                hideDayGranulate: false,
                plugins: 'responsive',
                responsiveConfig: {
                    'width < 1280': {
                        compactView: true
                    },
                    'width > 1280': {
                        compactView: false
                    }
                }
            }]
        };
        var grid = {
            xtype: 'grid',
            id: this.cid + "grid",
            store: store,
            flex: 1,
            minHeight: 200,
            emptyText: Lang.brak_danych,
            columns: [{
                header: Lang.czas,
                flex: 1,
                dataIndex: 'sxcat',
                renderer: function (value, metaData, record, rowIndex, colIndex, store, view) {
                    if (record.get('sxcat_label') != null && record.get('sxcat_label') !== "" && record.get('sxcat_label').includes("W")) {
                        var sxcat_lbl = record.get('sxcat_label');
                        return Ext.Date.format(new Date(value), 'd.m.Y') + " (" + sxcat_lbl + ")";
                    }
                    return Ext.Date.format(new Date(value), 'd.m.Y H:i');
                },
                sortable: false
            }, {
                header: Lang.arytmetyczny,
                flex: 1,
                dataIndex: 'arytm',
                sortable: false,
                renderer: function (value) {
                    return Ext.util.Format.number(value, '0.00');
                }
            }, {
                header: Lang.sonda,
                flex: 1,
                dataIndex: 'sonda',
                sortable: false,
                renderer: function (value) {
                    return Ext.util.Format.number(value, '0.00');
                }
            }, {
                header: Lang.roznica,
                flex: 1,
                dataIndex: 'diff',
                xtype: 'numbercolumn',
                format: '0.0',
                sortable: false,
                renderer: function (value) {
                    return Ext.util.Format.number(value, '0.00');
                }
            }]
        };
        var chart = this.getChart();
        chart.store = store;
        var hiddenPdfDiv = {
            xtype: 'box',
            hidden: true,
            height: 720,
            width: 1280,
            html: '<div id="test"></div>',
            hideMode: 'offsets'
        };
        this.items = [topPanel, periodSelector, chart, grid, hiddenPdfDiv];
        this.callParent(arguments);
    },
    show: function () {
        if (Ext.os.deviceType != "Desktop") {
            var chartComponent = Ext.getCmp(this.cid + 'chart');
            var mouseMoveY = null;
            chartComponent.body.on("swipe", function (event, node, options, eOptions) {
                var deltaY = event.distance;
                if (event.direction == "down")
                    deltaY = deltaY * -1;
                this.scrollBy(0, deltaY, true);
            }, this);
            chartComponent.body.on("mousemove", function (event, node, options, eOptions) {
                var deltaY = 0;
                if (mouseMoveY == null) {
                    mouseMoveY = event.parentEvent.clientY;
                } else if (mouseMoveY != event.parentEvent.clientY) {
                    deltaY = mouseMoveY - event.parentEvent.clientY;
                }
                this.scrollBy(0, deltaY, true);
            }, this);
        }
        this.callParent(arguments);
    },
    loadZbiornikiCombo: function () {
        var zbiornik = Ext.getCmp(this.cid + "idzbiornik");
        sendAjaxDataJsonRpcL("rest/zbiorniki/getShortList", null, this, function (data) {
            if (data.status) {
                zbiornik.store.loadData(data.data);
                this.show();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    closeOp: function () {
        this.close();
    },
    onReportReload: function () {
        var zbiornik = Ext.getCmp(this.cid + "idzbiornik");
        if (!zbiornik.isValid()) {
            Ext.MessageBox.alert(Lang.error, Lang.pole_nie_moze_byc_puste);
            return;
        }
        var aggregationSeed = this.getSeed();
        var period = this.getPeriod();
        if (this.rendered)
            this.mask(Lang.wczytywanie_danych, 'loading-indicator');
        sendAjaxDataJsonRpcL("rest/skppom/getAggregated", {
            datefrom: period.dateLocalFrom,
            dateto: period.dateLocalTo,
            aggrseed: aggregationSeed,
            idzbiornik: zbiornik.getValue()
        }, this, function (data) {
            if (data.status) {
                var dataForStore = data.data;
                var grid = Ext.getCmp(this.cid + "grid");
                var chart = Ext.getCmp(this.cid + "chart");
                grid.store.loadData(dataForStore);
                dataForStore2 = [];
                dataForStore.forEach(record => {
                    let rec2 = record;
                    rec2.sxcat = new Date(rec2.sxcat.replace(' ', 'T'));
                    dataForStore2.push(rec2);
                });
                chart.store.loadData(dataForStore2);
                if (this.rendered)
                    this.unmask();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    downloadPDF: function () {
        var zbiornik = Ext.getCmp(this.cid + "idzbiornik");
        if (!zbiornik.isValid()) {
            Ext.MessageBox.alert(Lang.error, Lang.pole_nie_moze_byc_puste);
            return;
        }
        if (Ext.getCmp(this.cid + "chart").getStore().count() <= 0) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_danych);
            return;
        }
        var series = Ext.getCmp(this.cid + "chart").getSeries();
        var aggregationSeed = this.getSeed();
        var period = this.getPeriod();
        var chart = Ext.create('Ext.chart.CartesianChart', {
            xtype: 'cartesian',
            legend: {
                type: 'sprite',
                docked: 'top'
            },
            height: 720,
            width: 1280,
            store: Ext.getCmp(this.cid + "chart").getStore(),
            captions: {
                title: Lang.poziom_plynu_w_zbiorniku
            },
            //"Wyciszenie ostrzeżenia w konsoli"
            downloadServerUrl: 'http://svg.sencha.io',
            axes: [{
                type: 'numeric',
                fields: ['arytm', 'sonda', 'diff'],
                position: 'left',
                grid: true
            }, {
                type: 'time',
                position: 'bottom',
                fields: ['sxcat'],
                grid: true,
                label: {
                    rotate: {
                        degrees: -80
                    }
                },
                style: {
                    estStepSize: 100
                },
                visibleRange: [0, 1]
            }],
            series: [{
                type: 'line',
                title: Lang.arytmetyczny,
                xField: 'sxcat',
                yField: 'arytm',
                step: true,
                style: {
                    lineWidth: 2
                },
                marker: {
                    radius: 1,
                    lineWidth: 2
                },
                hidden: series[0].getHidden()
            }, {
                type: 'line',
                title: Lang.sonda,
                xField: 'sxcat',
                yField: 'sonda',
                step: true,
                style: {
                    lineWidth: 2
                },
                marker: {
                    radius: 1,
                    lineWidth: 2
                },
                hidden: series[1].getHidden()
            }, {
                type: 'line',
                title: Lang.roznica,
                xField: 'sxcat',
                step: true,
                yField: 'diff',
                style: {
                    lineWidth: 2
                },
                marker: {
                    radius: 1,
                    lineWidth: 2
                },
                hidden: series[2].getHidden()
            }]
        });
        chart.on('redraw', function () {
            postFormAsync("rest/skppom/downloadExportAggregated", {
                datefrom: period.dateLocalFrom,
                dateto: period.dateLocalTo,
                aggrseed: aggregationSeed,
                idzbiornik: zbiornik.getValue(),
                image: chart.getImage().data
            }, null);
            Ext.defer(function () {
                chart.destroy();
            }, 1000);
        });
        chart.render(Ext.get("test"));
    },
    getChart: function () {
        return {
            xtype: 'cartesian',
            scrollable: true,
            id: this.cid + "chart",
            height: 500,
            legend: {
                type: 'sprite',
                docked: 'top'
            },
            plugins: {
                chartitemevents: {
                    moveEvents: true
                }
            },
            captions: {
                title: Lang.poziom_plynu_w_zbiorniku
            },
            //"Wyciszenie ostrzeżenia w konsoli"
            downloadServerUrl: 'http://svg.sencha.io',
            axes: [{
                type: 'numeric',
                fields: ['arytm', 'sonda', 'diff'],
                position: 'left',
                grid: true
            }, {
                type: 'time',
                position: 'bottom',
                fields: ['sxcat'],
                grid: true,
                label: {
                    rotate: {
                        degrees: -80
                    }
                },
                style: {
                    estStepSize: 100
                },
                visibleRange: [0, 1]
            }],
            series: [{
                type: 'line',
                title: Lang.arytmetyczny,
                xField: 'sxcat',
                yField: 'arytm',
                step: true,
                style: {
                    lineWidth: 2
                },
                marker: {
                    radius: 1,
                    lineWidth: 2
                }
            }, {
                type: 'line',
                title: Lang.sonda,
                xField: 'sxcat',
                yField: 'sonda',
                step: true,
                style: {
                    lineWidth: 2
                },
                marker: {
                    radius: 1,
                    lineWidth: 2
                }
            }, {
                type: 'line',
                title: Lang.roznica,
                xField: 'sxcat',
                step: true,
                yField: 'diff',
                style: {
                    lineWidth: 2
                },
                marker: {
                    radius: 1,
                    lineWidth: 2
                }
            }]
        };
    },
    getPeriod: function () {
        var period = Ext.getCmp(this.cid + "datemanipulationt").getValue();
        var reportType = Ext.getCmp(this.cid + "reporttype").getValue();
        if (reportType === "quarterday") {
            var originalDateFrom = period.dateLocalFrom;
            var mFrom = moment(originalDateFrom);
            var mTo = moment(period.dateLocalTo);
            var newFrom = mFrom.clone().subtract(2, 'months');
            period.dateLocalFrom = Ext.Date.format(newFrom.toDate(), Date.patterns.ISO8601Short) + " 00:00:00";
            period.dateLocalTo = Ext.Date.format(mTo.toDate(), Date.patterns.ISO8601Short) + " 23:59:59";
        }
        return period;
    },
    getSeed: function () {
        var reportType = Ext.getCmp(this.cid + "reporttype").getValue();
        var seed = "";
        if (reportType == "daily") {
            seed = "hour";
        }
        if (reportType == "weekday") {
            seed = "hour";
        }
        if (reportType == "monthday") {
            seed = "hour";
        }
        if (reportType == "quarterday") {
            seed = "hour";
        }
        return seed;
    },
    onChangeReportType: function () {
        var creporttype = Ext.getCmp(this.cid + "reporttype");
        var rp = creporttype.getValue();
        var stateV = null;
        if (rp == "daily") {
            stateV = "day";
        }
        if (rp == "weekday") {
            stateV = "week";
        }
        if (rp == "monthday") {
            stateV = "month";
        }
        if (rp == "quarterday") {
            stateV = "month";
        }
        var cdatemanipulationt = Ext.getCmp(this.cid + "datemanipulationt");
        cdatemanipulationt.changeStateValue(stateV);
    },
    clearAll: function () {
        var grid = Ext.getCmp(this.cid + "grid");
        var chart = Ext.getCmp(this.cid + "chart");
        Ext.suspendLayouts();
        chart.destroy();
        grid.store.remove(grid.store.getData());
        grid.store.load();
        var newChart = this.getChart();
        newChart.store = grid.store;
        this.insert(2, newChart);
        Ext.resumeLayouts(true);
    }
});
